
import './chartloading.scss';

export default function Index({ spin, children }: {
    spin?: boolean,
    children: any
}) {

    if (spin) {
        return <div className="chartLoading">
            <span className="item first"></span>
            <span className='item'></span>
            <span className='item'></span>
            <span className='item'></span>
            <span className='item'></span>
        </div>
    } else {
        return <>
            {children}
        </>
    }

}